/**
 * 匹配文字高亮效果
 * @param keyword
 * @param content
 * @returns
 */
export function highlightText(keyword: string, content: string): string {
  if (!keyword) return content // 如果没有关键词，直接返回原内容

  // 创建正则表达式，匹配大小写不敏感
  const regex = new RegExp(`(${keyword})`, 'gi')
  // 替换匹配项并加上高亮样式
  const highlightedContent = content.replace(regex, '<span class="bgchighlight">$1</span>')

  return highlightedContent // 返回高亮后的内容
}
